import Assignments from './styled';

export default Assignments;
